/**
 * author: Ananthapadmanabhan V K
 */
import React from "react";
import "./SuperAdminMain.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import CompanyCreate from "../CompanyCreate/CompanyCreate";
import { withTranslation } from "react-i18next";
import CompanyList from "../CompanyList/CompanyList";
import SAdminHeader from "../SAdminHeader/SAdminHeader";
import SAdminSidebar from "../SAdminSidebar/SAdminSidebar";
import CompanyProfile from "../CompanyProfile/CompanyProfile";
import Subscriptions from "../Subscriptions/Subscriptions";
import AssignSubscription from "../AssignSubscription/AssignSubscription";
import InvalidRoutePage from "../../InvalidRoutePage/InvalidRoutePage";
import SAdminSettingsTab from "../SAdminSettingsTab/SAdminSettingsTab";
import Forms from "../../Common/Forms/Forms";
import Sidebar from "../../Common/Sidebar/Sidebar";
import SADocuments from "../SADocuments/SADocuments";
import UserActivities from "../UserActivities/UserActivities";
import IncidentType from "../IncidentType/IncidentType";
import UserList from "../../Common/User/UserList";
import UserForm from "../../Common/User/UserForm";
import AddMetric from "../../Common/Standards/Metric/Metric";
import Standards from "../../Common/Standards/Standards";
import Topics from "../../Common/Standards/Topics/Topics";
import Metric from "../../Common/Standards/Metric/Metric";
import DataPoints from "../../Common/Standards/DataPoints/DataPoints";
import TopicsAdmin from "../../Common/Standards/TopicsAdmin/TopicsAdmin";
import OfficePageList from "../OfficePages/OfficePageList";
import { OfficePageType } from "../../../core/constants/common";
import OfficePageEditor from "../OfficePages/OfficePageEditor";
import FormList from "../../Common/Forms/FormList";
import GeneralDisclosures from "../../Common/Disclosures/GeneralDisclosures";
import GDQuestionList from "../../Common/Disclosures/GDQuestionList";
import GraphConfigList from "../DashboardGraphConfig/GraphConfigList";
import GraphConfigForm from "../DashboardGraphConfig/GraphConfigForm";
import GraphSetList from "../DashboardGraphConfig/GraphSetList";
import AssignGraphConfig from "../AssignGraph/AssignGraphConfig";
import ESGStandards from "../Standard/ESGStandards";
import StdTemplateConfigContainer from "../Standard/StdTemplateConfigContainer";
import PlatformCodeMapping from "../PlatformCodeMapping/PlatformCodeMapping";
import PartnerUIConfig from "../Partner/PartnerUIConfig";
import QualitativeQuestionsView from "../../Common/Standards/Questions/QualitativeQuestionsView";
import StakeholderLibrary from "../StakeholderLibrary/StakeholderLibrary";
import OnlineUserList from "../../Common/User/OnlineUserList";
import PagesAndSessionUserList from "../../Common/User/PagesAndSessionUserList";
import MaterialIssues from "../MaterialIssues/MaterialIssues";
import Questions from "../Questions/Questions";
import ReportPrompting from "../ReportPrompting/ReportPrompting";
import ConfigureThirdParties from "../ConfigureThirdParties/ConfigureThirdParties";
import GHGEmissionDatasetContainer from "../GHGDatasets/GHGEmissionDatasetContainer";
import EmissionDatasetVersionManagement from "../GHGDatasets/EmissionDatasetVersionManagement";
import UomVersionManagement from "../Uom/UomVersionManagement";
import UomContainer from "../Uom/UomContainer";
import EmailLog from "../../Common/EmailLog/EmailLog";

const SuperAdminMain = ({ t }) => {
  return (
    <div>
      <SAdminHeader></SAdminHeader>
      <Sidebar />
      <div className="page_wrapper">
        <Routes>
          <Route
            path="/"
            exact={true}
            element={<Navigate replace to="/admin/list_company" />}
          />
          <Route path="/list_company" element={<CompanyList />} />
          <Route path="/create_company" element={<CompanyCreate />} />
          <Route path="/edit_company" element={<CompanyCreate />} />
          <Route path="/company_profile" element={<CompanyProfile />} />
          <Route path="/configurations" element={<SAdminSettingsTab />}>
          </Route>
          <Route path="/documents" element={<SADocuments />} />
          <Route path="/assessments" element={<Forms />} />
          <Route path="/subscriptions" element={<Subscriptions />} />
          <Route path="/assign_subscription" element={<AssignSubscription />} />
          <Route path="/not_found" element={<InvalidRoutePage />} />
          <Route path="/incident_types" element={<IncidentType />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/online_users" element={<OnlineUserList />} />
          <Route path="/pages_session_users" element={<PagesAndSessionUserList />} />
          <Route path="/user_form" element={<UserForm />} />
          <Route path="/standard" element={<Standards />} />
          <Route path="/metric/:std_id/:topic_id" element={<AddMetric />} />
          <Route path="/topiclist/:std_id" element={<TopicsAdmin />} />
          <Route path="/metriclist/:std_id/:topic_id" element={<Metric />} />
          <Route path="/datapointlist/:std_id/:topic_id/:metric_id" element={<DataPoints />} />
          <Route
            path="*"
            element={<Navigate replace to="/company_admin/not_found" />}
          />
          <Route path="/activity_log" element={<UserActivities />} />
          <Route path="/terms" element={<OfficePageList type={OfficePageType.TERMS_OF_USE} />} />
          <Route path="/privacy_notice" element={<OfficePageList type={OfficePageType.PRIVACY_NOTICE} />} />
          <Route path="/gdpr" element={<OfficePageList type={OfficePageType.GDPR_STATEMENT} />} />
          <Route path="/office_page_editor/:type" element={<OfficePageEditor />} />
          <Route path="/forms" element={<FormList />} />
          <Route path="/disclosures" element={<GeneralDisclosures />} />
          <Route path="/gd_questions/:gd_id" element={<GDQuestionList />} />
          <Route path="/dash_graph_config" element={<GraphConfigList />} />
          <Route path="/dash_graph_config/form" element={<GraphConfigForm />} />
          <Route path="/graph_sets" element={<GraphSetList />} />
          <Route path="/assign_graph" element={<AssignGraphConfig />} />
          <Route path="/esg_std" element={<ESGStandards />} />
          <Route path="/std_config" element={<Standards forSuperAdmin={true} />} />
          <Route path="/std_template_config/:stdId" element={<StdTemplateConfigContainer />} />
          <Route path="/plat_code_map" element={<PlatformCodeMapping />} />
          <Route path="/partner_ui_config" element={<PartnerUIConfig />} />
          <Route path="/qualquestions/:std_id/:topic_id/:metric_id" element={<QualitativeQuestionsView />} />
          <Route path="/stakeholders" element={<StakeholderLibrary />} />
          <Route path="/material_issues" element={<MaterialIssues />} />
          <Route path="/question_answer_lib" element={<Questions />} />
          <Route path="/report_prompting" element={<ReportPrompting />} />
          <Route path="/third_parties_config" element={<ConfigureThirdParties />} />
          <Route path="/ghg_datasets" element={<GHGEmissionDatasetContainer />} />
          <Route path="/ghg_datasets/:datasetName/versions" element={<EmissionDatasetVersionManagement />} />
          <Route path="/uom" element={<UomContainer />} />
          <Route path="/uom/versions" element={<UomVersionManagement />} />
          <Route path="/email_log" element={<EmailLog />} />
        </Routes>

      </div>
    </div>
  );
};

export default withTranslation()(SuperAdminMain);
